module.exports = __webpack_public_path__ + "img/logo-white2.a1f45403.png";